const mapView = (width) => {

    const list       = $('.js-map-list-view');
    const map        = $('.js-map-view');
    const mapButton  = $('.js-control-map');
    const listButton = $('.js-control-list');
    let noHide       = true;

    mapButton.on('change', function(){
        if ( $(this).prop('checked' )) {
            list.fadeOut(200);
            map.fadeIn(200);
        }
    });
    listButton.on('change', function(){
        if ( $(this).prop('checked') ) {
            map.fadeOut(200);
            list.fadeIn(200);
        }
    });


    $(window).on('load resize', function(){
        if ( window.deviceWidth <= width ) {
            if ( noHide ) {
                noHide = false;
                list.hide();
            }
        }
        else {
            noHide = true;
            list.removeAttr('style');
            map.removeAttr('style');
        }
    });

}